import React, { Component } from "react";
import { createPortal } from "react-dom";
import moment from "moment";
import { get } from "lodash";
import { isValidArray } from "../../helper";
import { PreNode } from "../reusableComponent";
import { Link } from "react-router-dom";
import { PATHS, VIDEO_FORMATS } from "../../constant";
import { connect } from "react-redux";
import { VideoPlayerModal } from "../reusableComponent/modal/videoPlayerModal";
import ZoomLevelProvider from "../projectList/ZoomLevelProvider";
import pp_pending_text_icon from "../../assets/pp_pending_text_icon.svg";
import pending_for_approval from "../../assets/unapproved icon.svg";
import pp_modified_icon from "../../assets/pp_modified_icon.svg";
import pp_approved_icon from "../../assets/pp_approved_icon.svg";
import { ConfirmationComponent } from "../ConfirmationComponent";
import Approve from "../reusableComponent/ministry/Approve";
import ModifyAndApprove from "../reusableComponent/ministry/modifyAndApprove";
import { LoaderPage } from "../../component/Loader";

// ---- Portal-based tooltip icon, avoids ancestor overflow clipping ----
class TooltipIcon extends Component {
  constructor(props) {
    super(props);
    this.iconRef = React.createRef();
    this.state = { show: false, coords: null };
  }

  componentDidMount() {
    // capture: true so we catch scroll on any nested scrollable ancestor too,
    // since scroll events don't bubble
    window.addEventListener("scroll", this.handleScroll, true);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll, true);
  }

  handleScroll = () => {
    if (this.state.show) {
      this.setState({ show: false, coords: null });
    }
  };

  handleEnter = () => {
    if (!this.iconRef.current) return;
    const rect = this.iconRef.current.getBoundingClientRect();
    this.setState({
      show: true,
      coords: {
        top: rect.top,
        right: window.innerWidth - rect.right
      }
    });
  };

  handleLeave = () => {
    this.setState({ show: false });
  };
  render() {
    const {
      iconSrc,
      imgClassName,
      tooltipClassName,
      children,
      style
    } = this.props;
    const { show, coords } = this.state;

    return (
      <div
        className="icon-wrapper"
        style={style}
        ref={this.iconRef}
        onMouseEnter={this.handleEnter}
        onMouseLeave={this.handleLeave}
      >
        <img src={iconSrc} className={imgClassName} />
        {show &&
          coords &&
          createPortal(
            <div
              className={tooltipClassName}
              style={{
                position: "fixed",
                top: coords.top,
                right: coords.right - 25, // shift box slightly right so triangle lines up under icon
                transform: "translateY(-100%)",
                marginTop: "-13px",
                zIndex: 9999
              }}
            >
              {children}
            </div>,
            document.body
          )}
      </div>
    );
  }
}
// ---- END TooltipIcon ----

class IssueActivityHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showVideoModal: false,
      videoUrl: "",
      videoTitle: "",
      fileName: "",
      zoomPercentage: 100,
      history: props.history || "",
      showLoader: false,
      file: []
    };
  }
  componentDidUpdate(prevProps) {
    const { history, file } = this.props;

    if (prevProps.history !== history) {
      this.setState({
        history: history
      });
    }
  }
  showVideoPlayerModal() {
    const { showVideoModal, videoUrl, fileName, showCommentPopUp } = this.state;
    return (
      <VideoPlayerModal
        showVideoModal={showVideoModal}
        url={videoUrl}
        videoTitle={fileName}
        onClose={() =>
          this.setState({
            showVideoModal: false,
            videoUrl: null,
            fileName: null
          })
        }
      />
    );
  }

  convertTimestampToDate(timestamp) {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = date.getMonth() + 1; // months are 0-based
    const day = date.getDate();
    const paddedDay = day < 10 ? `0${day}` : day;
    const paddedMonth = month < 10 ? `0${month}` : month;
    return `${paddedDay}/${paddedMonth}/${year}`;
  }
  handleZoomChange = zoom => {
    this.setState({ zoomPercentage: zoom });
  };
  fontSize = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "8.5px";
    } else {
      return "9px";
    }
  };
  paddingLeft = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "3px";
    } else {
      return "5px";
    }
  };
  padding = zoomPercentage => {
    if (zoomPercentage == 100) {
      return "7px 4px 7px 4px";
    } else {
      return "7px 6px 7px 6px";
    }
  };
  displayLoader = data => {
    if (data) {
      this.setState({ showLoader: true });

      setTimeout(() => {
        this.setState({ showLoader: false });
      }, 1500);
    }
  };
  getAllComments = data => {
    this.props.getAllComments(data);
  };

  // Normalizes files/fileManagerDTOSet into a single array to render.
  getAttachmentList() {
    const { history } = this.state;
    const files = get(history, "files");
    const fileManagerDTOSet = get(history, "fileManagerDTOSet");

    if (isValidArray(files)) return files;
    if (isValidArray(fileManagerDTOSet)) return fileManagerDTOSet;
    return [];
  }

  renderAttachment = (file, index) => {
    const { zoomPercentage } = this.state;
    const extension = file.name
      ? file.name.substr(file.name.lastIndexOf(".") + 1, file.name.length)
      : "";

    const displayName = file.title
      ? file.title.length > 20
        ? file.title.substring(0, 18) + ".."
        : file.title
      : file.name
      ? file.name.length > 20
        ? file.name.substring(0, 18) + ".."
        : file.name
      : "";

    return (
      <div
        className="uploaded-file-issue-comments"
        key={file.id || file.s3Url || index}
        onClick={() => window.open(file.s3Url, "_blank")}
        style={{
          padding: this.padding(zoomPercentage)
        }}
      >
        <div className="file-detail">
          <div>
            <div className="upload-icon">
              <span>{extension}</span>
            </div>
          </div>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={file.s3Url}
            style={{
              fontSize: this.fontSize(zoomPercentage),
              paddingLeft: this.paddingLeft(zoomPercentage)
            }}
          >
            {displayName}
          </a>
        </div>
      </div>
    );
  };

  render() {
    const {
      projectData,
      pendingComments,
      approvedBy,
      modifiedBy,
      buttonVisibility,
      MarginTop
    } = this.props;
    const {
      zoomPercentage,
      showCommentPopUp,
      file,
      history,
      showLoader
    } = this.state;
    const pathProjDetail = window.location.pathname == "/detail-project";
    let projectId = get(projectData, "data.id", null);
    const attachmentList = this.getAttachmentList();

    return (
      <React.Fragment>
        <LoaderPage loading={showLoader} />
        {this.state.showVideoModal === true && this.showVideoPlayerModal()}
        <ZoomLevelProvider onZoomChange={this.handleZoomChange} />
        <div
          className={`activity-history comment-item ${
            pendingComments ? "comment-pendingComments" : ""
          }`}
          style={{
            width: zoomPercentage == 90 ? "90%" : "100%"
          }}
        >
          <span className="activity-date" style={{ fontFamily: "mpsb" }}>
            {moment(get(history, "date")).format("DD/MM/YYYY, hh:mm A")}
          </span>
          {(get(history, "assignedTo") && (
            <span className="activity-by" style={{ fontFamily: "mpsb" }}>
              {get(history, "assignedTo", "NA") || "-"}
            </span>
          )) ||
            null}
          <div className="activity-icons">
            {pendingComments && (
              <TooltipIcon
                iconSrc={pending_for_approval}
                imgClassName="pending_for_approval_icon"
                tooltipClassName="pending-custom-tooltip"
              >
                Pending for Approval
              </TooltipIcon>
            )}
          </div>

          <div className="activity-icons">
            {/* Modified Icon */}
            {modifiedBy && (
              <TooltipIcon
                iconSrc={pp_modified_icon}
                tooltipClassName="approved-custom-tooltip"
              >
                Modified by{" "}
                {(get(history, "modifiedBy") && (
                  <span className="activity-by" style={{ marginRight: 3 }}>
                    {get(history, "modifiedBy", "NA") || "-"} (
                    {get(history, "modifiedByGroupName", "NA")})
                  </span>
                )) ||
                  null}{" "}
                |{" "}
                <span className="pp-activity-date" style={{ marginLeft: 3 }}>
                  {moment(get(history, "modifiedDate")).format("DD/MMM/YYYY")}
                </span>
              </TooltipIcon>
            )}
            {/* Approved Icon */}
            {approvedBy && (
              <TooltipIcon
                iconSrc={pp_approved_icon}
                imgClassName={zoomPercentage == 90 ? "" : "pp_approved_icon"}
                tooltipClassName="approved-custom-tooltip"
              >
                Approved by{" "}
                {(get(history, "approvedBy") && (
                  <span className="activity-by" style={{ marginRight: 3 }}>
                    {get(history, "approvedBy", "NA") || "-"} (
                    {get(history, "approvedByGroupName", "NA")})
                  </span>
                )) ||
                  null}{" "}
                |{" "}
                <span className="pp-activity-date" style={{ marginLeft: 3 }}>
                  {moment(get(history, "approvedDate")).format("DD/MMM/YYYY")}
                </span>
              </TooltipIcon>
            )}
          </div>
          {(get(history, "message") || []).map((message, index) => {
            const match = message.match(/<b>(.*?)<\/b>/);
            const targetDate = get(history, "date");
            const deployedDate = new Date("2026-07-08").getTime();
            return (
              <div
                className={`activity-comment`}
                key={`comment-${index}`}
                style={{ marginTop: MarginTop ? -12 : 5 }}
              >
                <PreNode classes={"update-prenode"}>
                  {/[\u0900-\u097F]/.test(message) ? (
                    <span
                      className={`${
                        pathProjDetail || window.scrollY < 500
                          ? "hindi-text-wrap"
                          : "hindi-text-wrap-comment hindi-line-height"
                      }`}
                      dangerouslySetInnerHTML={{ __html: message }}
                      style={{ lineHeight: "1.3" }}
                    />
                  ) : (
                    <>
                      <span
                        dangerouslySetInnerHTML={{
                          __html:
                            targetDate >= deployedDate
                              ? message.replace("on IIG", "on CRIP")
                              : message
                        }}
                      />
                      {match &&
                      match[1] == "Pending with PMG" &&
                      get(history, "issueReviewedBySM") != null ? (
                        <div style={{ marginTop: "8px" }}>
                          <span style={{ fontFamily: "mpsb" }}>
                            Ministry Review:
                          </span>{" "}
                          {get(history, "issueReviewedBySM") ? "Yes" : "No"}
                        </div>
                      ) : (
                        ""
                      )}
                    </>
                  )}
                </PreNode>
                <PreNode classes={"update-prenode"}>
                  {get(history, "taggedIssueId") ? (
                    <Link
                      to={{
                        pathname: PATHS.ISSUE_DETAIL,
                        search: `?issueId=${get(
                          history,
                          "taggedIssueId"
                        )}&&projectId=${projectId}`
                      }}
                      className={`test-link ${
                        message.match(/[\u0900-\u097F]/)
                          ? "hindi-line-height"
                          : ""
                      }`}
                    >
                      #{get(history, "taggedIssueId", "NA")}
                    </Link>
                  ) : (
                    ""
                  )}
                </PreNode>
              </div>
            );
          })}

          {attachmentList.length > 0 && (
            <section
              className="display-attachments-section-issue-comments attachments"
              style={{ marginBottom: 3 }}
            >
              <div className="uploaded-file-wrapper-issue-comments">
                {attachmentList.map((file, index) =>
                  this.renderAttachment(file, index)
                )}
              </div>
            </section>
          )}

          {this.props.type == "comment" &&
          history.tentativeResolutionDate !== null &&
          history.tentativeResolutionDate !== undefined ? (
            <div
              style={{
                marginTop: "8px",
                fontFamily: "mpb",
                fontSize: "12px",
                textAlign: "left"
              }}
            >
              Tentative Issue Resolution Date:{" "}
              <span style={{ color: "#212529", fontFamily: "mpsb" }}>
                {this.convertTimestampToDate(
                  new Date(history.tentativeResolutionDate)
                )}
              </span>
            </div>
          ) : null}
          {get(history, "isPragatiComment") ? (
            <div
              style={{
                marginTop: "3px",
                fontFamily: "mpb",
                fontSize: "12px",
                textAlign: "left"
              }}
            >
              Source:{" "}
              <span style={{ color: "#0BA6D9", fontFamily: "mpsb" }}>
                PRAGATI
              </span>
            </div>
          ) : null}
          <div
            // style={{ display: history.canApprove  ? "flex" : "none" }}
            style={{
              display: history.canApprove && buttonVisibility ? "flex" : "none",
              marginBottom: 15,
              paddingTop: history.canApprove && buttonVisibility ? 7 : 0
            }}
          >
            <Approve
              commentId={history.commentId}
              getAllComments={this.getAllComments}
            />
            <ModifyAndApprove
              commentId={history.commentId}
              getAllComments={this.getAllComments}
              projectData={projectData}
              history={history.message[0]}
              file={get(history, "files") || get(history, "fileManagerDTOSet")}
              displayLoader={this.displayLoader}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    projectData: state.projectDetailsReducer.projectData
  };
}

export default connect(
  mapStateToProps,
  null
)(IssueActivityHistory);
